import styled from "styled-components";


export const AmountSelectorWrapper = styled.div`

  max-width: 420px;
  font-family: Arial, sans-serif;


.title {
font-size: 13px;
    margin-bottom: 10px;
    color: #444;
    font-weight: 600;
}

.amount-card {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 14px;
  border-radius: 10px;
  border: 1px solid #dce4f2;
  background: #f3f7ff;
  margin-bottom: 10px;
  cursor: pointer;
}

.amount-card input {
  transform: scale(1.2);
  accent-color: #3f6fb6;
}

.amount-card.active {
  background: #4f77b5;
  color: #fff;
}

.amount-card.active .label,
.amount-card.active .value {
  color: #fff;
}

.amount-text {
  display: flex;

}

.label {
  font-size: 12px;
  font-weight: 500;
  margin-right: 4px;
}

.value {
  font-size: 14px;
  font-weight: bold;
}

`;